import styled from "@emotion/styled";
import { BaseCell } from "./BaseCell";

const Container = styled(BaseCell)<{ flex: number }>`
  color: rgba(49, 57, 74, 1);
  flex: ${(props) => props.flex};
  font-size: 12px;
`;

const Push = styled.div`
  content: " ";
  width: 40px;
`;
export const HeaderCell = ({ title }: { title?: string }) => {
  // This is bad, and I'm ashamed
  const isWide = title && ["Name", "File name"].includes(title);
  return (
    <Container flex={isWide ? 2 : 1}>
      {title === "Name" && <Push />}
      {title}
    </Container>
  );
};
